import { useContext } from "react";
import { PagamentoLoteContext } from "../contexts/PagamentoLoteContext";

export function usePagamentoLote() {
  const context = useContext(PagamentoLoteContext);
  if (!context) {
    throw new Error("usePagamentoLote deve ser usado dentro de um PagamentoLoteProvider");
  }
  return context;
}
